var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7CE49F00-FDB5-4B1F-9D8B-55798827C92D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Client-|-Health-System-Level---Month-Date-range",
    transform: "translate(-1543.000000, -131.000000)",
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    transform: "translate(1543.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,12 L8,10 L10,10 L10,12 L8,12 Z M4,12 L4,10 L6,10 L6,12 L4,12 Z M12,12 L12,10 L14,10 L14,12 L12,12 Z M8,16 L8,14 L10,14 L10,16 L8,16 Z M4,16 L4,14 L6,14 L6,16 L4,16 Z M12,16 L12,14 L14,14 L14,16 L12,16 Z M0,20 L0,1.5 L3.125,1.5 L3.125,0 L4.75,0 L4.75,1.5 L13.25,1.5 L13.25,0 L14.875,0 L14.875,1.5 L18,1.5 L18,20 L0,20 Z M1.5,18.5 L16.5,18.5 L16.5,7.75 L1.5,7.75 L1.5,18.5 Z M1.5,6.25 L16.5,6.25 L16.5,3 L1.5,3 L1.5,6.25 Z M1.5,6.25 L1.5,3 L1.5,6.25 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCalendarIcon);
export default __webpack_public_path__ + "static/media/white-calendar-icon.07e50a610b2e766a1f68cca3066fe5d9.svg";
export { ForwardRef as ReactComponent };